import React, { useEffect } from "react";

const FacebookCard = () => {
  useEffect(() => {
    // Load the Facebook SDK script
    const script = document.createElement("script");
    script.src =
      "https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v19.0";
    script.async = true;
    script.crossOrigin = "anonymous";
    script.defer = true;
    script.nonce = "c86tqsvz";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <div className="set-marquee object-fit-contain overflow-hidden">
        <div id="fb-root"></div>
        <div
          className="fb-page"
          data-adapt-container-width="true"
          data-height="261"
          data-hide-cover="false"
          data-href="https://www.facebook.com/profile.php?id=100083055402675"
          data-show-facepile="true"
          data-small-header="true"
          data-tabs="timeline"
          style={{ height: "350px" }}
        >
          <span
            style={{ verticalAlign: "bottom", width: "340px", height: "261px" }}
          >
            <iframe
              name="fb6f529184f57b844"
              width="1000px"
              height="261px"
              data-testid="fb:page Facebook Social Plugin"
              title="fb:page Facebook Social Plugin"
              frameBorder="0"
              allowTransparency="true"
              allowFullScreen="true"
              scrolling="no"
              allow="encrypted-media"
              src="https://www.facebook.com/v19.0/plugins/page.php?adapt_container_width=true&app_id=&container_width=358&height=261&hide_cover=false&href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D100083055402675&locale=en_GB&sdk=joey&show_facepile=true&small_header=true&tabs=timeline&width="
              style={{
                border: "none",
                visibility: "visible",
                width: "340px",
                height: "261px",
              }}
            ></iframe>
          </span>
        </div>
      </div>
    </div>
  );
};

export default FacebookCard;
